import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'enrich-dashboard',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardLayoutComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/layouts/dashboard/dashboard-layout.component.ts